var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5823 11.4141H4.58232C3.80732 11.4141 3.41982 11.4141 3.10148 11.4863C2.67758 11.5829 2.29106 11.7727 1.9808 12.0366C1.67054 12.3004 1.44746 12.629 1.33398 12.9894",
    stroke: "#FCFCFC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.66732 5.04167H11.334M4.66732 7.52083H8.83398M6.33398 15.6667C3.97732 15.6667 2.79815 15.6667 2.06648 15.044C1.33398 14.4221 1.33398 13.4198 1.33398 11.4167V5.75C1.33398 3.74683 1.33398 2.74454 2.06648 2.12262C2.79815 1.5 3.97732 1.5 6.33398 1.5H9.66732C12.024 1.5 13.2032 1.5 13.9348 2.12262C14.6673 2.74454 14.6673 3.74683 14.6673 5.75M9.66732 15.6667C12.024 15.6667 13.2032 15.6667 13.9348 15.044C14.6673 14.4221 14.6673 13.4198 14.6673 11.4167V8.58333",
    stroke: "#FCFCFC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndIcon);
export default __webpack_public_path__ + "static/media/indIcon.b27e560bea22bdf56619e521069338e2.svg";
export { ForwardRef as ReactComponent };